var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBeta = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 46,
  height: 20,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 20,
  x: 0.5,
  fill: "#00E2BC",
  rx: 10
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#25245F",
  d: "M13.612 9.692q.456.072.828.372.384.3.6.744.228.444.228.948 0 .636-.324 1.152-.324.504-.948.804-.612.288-1.452.288h-3.12V5.636h3q.852 0 1.452.288.6.276.9.756t.3 1.08q0 .744-.408 1.236a2.23 2.23 0 0 1-1.056.696m-3.096-.444h1.836q.768 0 1.188-.36t.42-.996-.42-.996-1.212-.36h-1.812zm1.932 3.852q.816 0 1.272-.384t.456-1.068q0-.696-.48-1.092-.48-.408-1.284-.408h-1.896V13.1zm5.427-6.576V9.32h3.048v.9h-3.048v2.88h3.408v.9h-4.5V5.624h4.5v.9zm10.209-.888v.888h-2.28V14h-1.092V6.524H22.42v-.888zm6.288 6.504h-3.648L30.052 14H28.9l3.024-8.316h1.26L36.196 14h-1.152zm-.312-.888-1.512-4.224-1.512 4.224z"
})));
export default SvgBeta;